<template>
    <v-menu
        v-model="showPopup"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="time"
                :label="label"
                readonly
                persistent-hint
                v-on="on"
                prepend-inner-icon="mdi-calendar-clock"
                :error-messages="errorMessages"
                :clearable="clearable"
            ></v-text-field>
        </template>
        <v-time-picker
            v-model="time"
            :min="min"
            :max="max"
            ref="VTimePicker"
            style="width: 100%"
        ></v-time-picker>
    </v-menu>
</template>

<script>
export default {
    name: 'TimePicker',
    props: {
        value: String,
        label: String,
        min: String,
        max: String,
        errorMessages: String,
        clearable: Boolean,
        required: Boolean
    },
    data () {
        return {
            showPopup: false,
            time: ''
        }
    },
    watch: {
        time () {
            this.$emit('input', this.time)
        },
        value () {
            this.time = this.value
        }
    }
}
</script>

<style scoped>

</style>
